import {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import LangMenus from "../LangMenus";
import {useQueryShopCar} from "../../../../api/orderShopcarDetail";
import {setCartCount} from "../../../../reducer/actions";
import cookies from "../../../../utils/cookies";
import CartMenusMall9 from "../CartMenus/CartMenusMall9";
import CartMenusMall2 from "../CartMenus/CartMenusMall2";
import MyMenus from "../MyMenus";
import './index.css';

export default function HeaderMenusRows(
  {
    nav,
    menus,
    navHandle,
    theme = 'white',
    iconStyle = {},
    style,
  }) {
  const [langMenus, setLangMenus] = useState(false);
  const [cartMenus, setCartMenus] = useState(false);
  const [myMenus, setMyMenus] = useState(false);
  const [shopGoodsList, setShopGoodsList] = useState([]);
  const [goodsList, setGoodsList] = useState([]);
  const { getCart } = useQueryShopCar();
  const state = useSelector(state => state);
  const dispatch = useDispatch();
  const agentInfo = cookies.getAgentInfo();
  
  const _navHandle = (item) => {
    if (item.icon === 'lang') {
      setLangMenus(true);
      return;
    }
    
    if (item.icon === 'user' &&
      cookies.get('MALL') &&
      cookies.get('MALL') === '9' &&
      cookies.getToken()) {
      setMyMenus(!myMenus);
      return;
    }
    
    if (item.icon === 'shop' &&
      cookies.get('MALL') &&
      ['2', '9'].includes(cookies.get('MALL')) &&
      cookies.getToken()) {
      setCartMenus(!cartMenus);
      return;
    }
    
    navHandle(item.icon);
  };
  
  const closeCartMenus = () => {
    setCartMenus(false);
  };
  
  const closeMyMenus = () => {
    setMyMenus(false);
  };
  
  /**
   * 获取购物车商品数量
   * @returns {Promise<void>}
   */
  const getCartGoods = async () => {
    let { data } = await getCart();
    if (data && data.shopCarList) {
      setShopGoodsList(data.shopCarList);
      let count = 0;
      let _goodsList = [];
      data.shopCarList.forEach((shop) => {
        count += shop.goodsList.length;
        _goodsList = [..._goodsList, ...shop.goodsList];
      });
      setGoodsList(_goodsList);
      dispatch(setCartCount(count));
    }
  };
  
  const closeMenus = () => {
    setLangMenus(false);
  };
  
  const navs = useMemo(()=>{
    let res = [...nav];
    if (agentInfo.isProduct === '0'){
      res = res.filter(item=>item.icon !== 'search')
    }
    return res;
  },[nav])
  
  useEffect(() => {
    getCartGoods();
    return () => {
    };
  }, []);
  
  return (
    <div className={`md:flex center flex-1 mdmax:hidden`} style={style}>
      {
        navs.map((item, i) => (
          <div className={`relative header-menus-row-divide ${theme}`}
               key={i}>
            <a
              id={item.icon === 'lang' ? 'LANG_MENUS_a' : ''}
              onClick={() => _navHandle(item)}
              className="relative px-[20px] h-[20px] flex items-center cursor-pointer">
              <i id={item.icon === 'lang' ? 'LANG_MENUS_i' : ''}
                 style={iconStyle}
                 className={`iconfont icon-${item.icon} text-[22px] ${theme === 'black' ? 'text-[#333]' : 'text-white'}`}/>
              
              {
                state.cartCount > 0 && item.icon === 'shop' &&
                <span className="absolute bottom-[-5px] right-[50%] bg-[#f5222d] inline-block
                                   w-[17px] h-[17px] text-[12px] rounded-full text-white text-center"
                      style={{ transform: 'translateX(20px)' }}>
                  {state.cartCount}
                </span>
              }
            </a>
            {
              item.icon === 'lang' && <LangMenus visible={langMenus} onClose={closeMenus}/>
            }
            {
              item.icon === 'user' && <MyMenus visible={myMenus}
                                               menus={menus}
                                               onClose={closeMyMenus}/>
            }
            {
              item.icon === 'shop' && cookies.get('MALL') === '9' &&
              <CartMenusMall9
                shopGoodsList={shopGoodsList}
                goodsList={goodsList}
                visible={cartMenus}
                onClose={closeCartMenus}/>
            }
            
            {
              item.icon === 'shop' && cookies.get('MALL') === '2' &&
              <CartMenusMall2
                shopGoodsList={shopGoodsList}
                goodsList={goodsList}
                visible={cartMenus}
                onClose={closeCartMenus}/>
            }
          </div>
        ))
      }
    </div>
  );
}
